import { render, staticRenderFns } from "./OfferMenu.vue?vue&type=template&id=4426148a&scoped=true&"
import script from "./OfferMenu.vue?vue&type=script&lang=ts&"
export * from "./OfferMenu.vue?vue&type=script&lang=ts&"
import style0 from "./OfferMenu.vue?vue&type=style&index=0&id=4426148a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4426148a",
  null
  
)

export default component.exports